module.exports = __webpack_public_path__ + "img/Pump_Speed.dcacd52a.png";